//index.js
var FormBase = require('./dist/vFormBase.vue')
module.exports = FormBase
